module.exports = __webpack_public_path__ + "695ce063.png";